// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_itemContainer__t1WRh {
  margin-bottom: 1.5rem; }

.styles_innerHeader__YHbey {
  margin-bottom: 1rem;
  border-bottom: 0.0625rem solid #8080802e; }
  .styles_innerHeader__YHbey > div:first-child {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap; }

.styles_interactionGroup__Qz6fi {
  display: flex;
  align-items: center;
  gap: 0.75rem; }

.styles_countButton__Wz7S7 {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.2s ease; }
  .styles_countButton__Wz7S7:hover:not(:disabled) {
    opacity: 0.7; }
  .styles_countButton__Wz7S7:disabled {
    cursor: default; }

.styles_countText__ExnbQ {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500; }

.styles_actionButton__zaZAG {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease; }
  .styles_actionButton__zaZAG:hover {
    background-color: rgba(0, 0, 0, 0.05); }
  .styles_actionButton__zaZAG:active {
    background-color: rgba(0, 0, 0, 0.1); }

.styles_actionIcon__Ql38A {
  font-size: 1.125rem;
  line-height: 1; }

.styles_interactionModal__Ad7Xv {
  max-width: 37.5rem;
  width: 90vw;
  max-height: 70vh;
  overflow: hidden;
  display: flex;
  flex-direction: column; }

.styles_interactionModalList__AItqB {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem 0; }

@media (max-width: 48rem) {
  .styles_interactionSection__Idgvw {
    flex-direction: column;
    gap: 1rem; }
  .styles_interactionGroup__Qz6fi {
    gap: 0.5rem; }
  .styles_countText__ExnbQ {
    font-size: 0.8125rem; }
  .styles_actionIcon__Ql38A {
    font-size: 1rem; } }

.styles_subteachingContainer__0qypb {
  border-color: #8080802e; }

.styles_subteachingsContainer__T1Qno {
  margin-top: 1rem; }
  .styles_subteachingsContainer__T1Qno > h2 {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    font-weight: 600;
    color: #80808080;
    text-decoration: underline; }
`, "",{"version":3,"sources":["webpack://./src/modules/teachings/components/TeachingsFeed/TeachingFeedItem/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,qBAAqB,EAAA;;AAIvB;EACE,mBAAmB;EACnB,wCCGgB,EAAA;EDLlB;IAII,aAAa;IACb,SAAS;IACT,eAAe,EAAA;;AAInB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,6BAA6B,EAAA;EAL/B;IAQI,YAAY,EAAA;EARhB;IAYI,eAAe,EAAA;;AAInB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC,EAAA;EATxC;IAYI,qCAAqC,EAAA;EAZzC;IAgBI,oCAAoC,EAAA;;AAIxC;EACE,mBAAmB;EACnB,cAAc,EAAA;;AAIhB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe,EAAA;;AAKjB;EACE;IACE,sBAAsB;IACtB,SAAS,EAAA;EAGX;IACE,WAAW,EAAA;EAGb;IACE,oBAAoB,EAAA;EAGtB;IACE,eAAe,EAAA,EAChB;;AAIH;EACE,uBCjGgB,EAAA;;ADoGlB;EACE,gBAAgB,EAAA;EADlB;IAGI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBCxGc;IDyGd,0BAA0B,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n// Feed Item Styles\n.itemContainer {\n  margin-bottom: 1.5rem;\n}\n\n// Interaction Section Styles\n.innerHeader {\n  margin-bottom: 1rem;\n  border-bottom: 0.0625rem solid $grey18;\n  &>div:first-child {\n    display: flex;\n    gap: 2rem;\n    flex-wrap: wrap;\n  }\n}\n\n.interactionGroup {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.countButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover:not(:disabled) {\n    opacity: 0.7;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.countText {\n  font-size: 0.875rem;\n  color: rgba(0, 0, 0, 0.6);\n  font-weight: 500;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  &:active {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n}\n\n.actionIcon {\n  font-size: 1.125rem;\n  line-height: 1;\n}\n\n// Modal Styles (shared for comments and votes)\n.interactionModal {\n  max-width: 37.5rem;\n  width: 90vw;\n  max-height: 70vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.interactionModalList {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 0;\n}\n\n\n// Responsive adjustments\n@media (max-width: 48rem) {\n  .interactionSection {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .interactionGroup {\n    gap: 0.5rem;\n  }\n\n  .countText {\n    font-size: 0.8125rem;\n  }\n\n  .actionIcon {\n    font-size: 1rem;\n  }\n}\n\n\n.subteachingContainer {\n  border-color: $grey18;\n}\n\n.subteachingsContainer {\n  margin-top: 1rem;\n  & > h2 {\n    margin-bottom: 1rem;\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: $grey50;\n    text-decoration: underline;\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemContainer": `styles_itemContainer__t1WRh`,
	"innerHeader": `styles_innerHeader__YHbey`,
	"interactionGroup": `styles_interactionGroup__Qz6fi`,
	"countButton": `styles_countButton__Wz7S7`,
	"countText": `styles_countText__ExnbQ`,
	"actionButton": `styles_actionButton__zaZAG`,
	"actionIcon": `styles_actionIcon__Ql38A`,
	"interactionModal": `styles_interactionModal__Ad7Xv`,
	"interactionModalList": `styles_interactionModalList__AItqB`,
	"interactionSection": `styles_interactionSection__Idgvw`,
	"subteachingContainer": `styles_subteachingContainer__0qypb`,
	"subteachingsContainer": `styles_subteachingsContainer__T1Qno`
};
export default ___CSS_LOADER_EXPORT___;
